import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import 'antd/dist/reset.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import BuscarProyecto from './components/BuscarProyecto/BuscarProyecto';
import ActualizarProyecto from './components/ActualizarProyecto/ActualizarProyecto';
import Organizaciones from './components/Organizaciones/Organizaciones';
import AccesoRestringido from './components/AccesoRestringido/AccesoRestringido';
import FileManager from './components/DetalleProyecto/FileManager';
import MerOrganizaciones from './components/Organizaciones/MerOrganizaciones';
import Poa from './components/Poa/Poa';
import LogosFooter from './components/LogosHeader/LogosFooter';
import NavBodecom from './components/header/navBodecom';
import LoginBodecom from './components/Login/loginBodecom';
import PrivateRoute from './components/Login/PrivateRoute';
import ReporteInformes from './components/Informes/InsumoReportes';
import MapaInicio from './components/mapas/mapaInicio';
import Inicio from './components/Inicio/Inicio';
import Participantes from './components/Participantes/Participantes';
import EsProyecto from './components/Estructuracion/esctructuracion';
import ProyectoView from './components/Estructuracion/proyecto_estructuracion';
import AcuerdosComerciales from './components/AcuerdosComerciales/AcuerdosComerciales';
import AppSlider from './components/appSlider/AppSlider';
import Formulario from './components/FormularioParticipantes/Formulario';
import Caracterizacion from './components/FormularioParticipantes/Caracteriazacion';
import Ippta from './components/Ippta/Ippta';
import Edah from './components/EncuestaEdah/Edah';
import MenuFortalecimiento from './components/producto_3/Fort_Capacidades/Menu/MenuFortalecimiento';
import CursoFortalecimiento from './components/producto_3/Fort_Capacidades/Participantes/FortalecimientoCap';
import CFCicloVida from './components/producto_3/Fort_Capacidades/CursosCiclosVida/FortalecimientoCVTab';
import PoaPlanOperativo from './components/poaReporte/PoaPlanOperativo';
import AcompanamientoOrg from './components/producto_3/Fort_Capacidades/AcompaOrganizaciones/AcompanamientoOrg';
import EscuelaDHAATab from './components/producto_3/Fort_Capacidades/DHAA/EscuelaDHHATap';
import EnfoqueGenero from './components/informe_genero/enfoque/enfoqueGenero';
import PlanAccion from './components/informe_genero/planes_accion/PlanAccion';
import ProcesarEDAH from './components/configuracion_admin/ProcesarEDAH';
import NovedadParticipantes from './components/ParticipanteNovedad/NovedadesPage';
import EcasParticipante from './components/ParticipanteEcas/ECATable';
import DashboardPrincipal from './components/ParticipanteVisita/PageVisitas';
import ForceLogoutModal from './components/Login/ForceLogoutModal';
import AdminPanel from './pages/AdminPanel';
import RepositorioUrl from './components/Inicio/Repositorio/RepositorioUrl';
import InformeActas from './components/InformeActas/Dashboard';
import ProyectEstructurado from './components/ProyectoEstructurado/HomePage';
import DashboardFinanciero from './components/Financiero/Dashboard/DashboardFinanciero';
import EstadoFinanciero from './components/Financiero/Configuracion/EstadoFinanciero/EstadoFinancieroPage';
import ProveedoresFinanciero  from './components/Financiero/Configuracion/ProveedoresFinancieros/ProveedoresPage';
import UnidadMedidaFinanciero from './components/Financiero/Configuracion/UnidadMedidaFinanciera/UnidadMedidaPage';
import ProductosFinanciero from './components/Financiero/Productos/ProductosPage';
import EntregasFinanciero from './components/Financiero/Entregas/EntregasPage';
import ProductosInforme from './components/Financiero/ProductosEntregas/ProductosEntregasPage';
import ReporteSeguimiento from './components/Seguimiento/ReporteSeguimiento';
import OcrEntregasPanel from './components/ocrActas/OcrEntregasPanel';


const AppContent = () => {
  const location = useLocation();
  const showNavAndFooter = !['/', '/acceso-restringido'].includes(location.pathname);

  return (
    <>
      {showNavAndFooter && <NavBodecom />}
      <ForceLogoutModal />
      <Routes>
        <Route path="/" element={<LoginBodecom />} />
        <Route path="/mapas" element={<PrivateRoute element={<MapaInicio />} />} />
        <Route path="/reportes" element={<PrivateRoute element={<ReporteInformes />} />} />
        <Route path="/es_proyectos" element={<PrivateRoute element={<EsProyecto />} />} />
        <Route path="/es_estructura/:oid" element={<PrivateRoute element={<ProyectoView />} />} />
        <Route path="/inicio/:slug?" element={<PrivateRoute element={<Inicio />} />} />
        <Route path="/buscar-proyecto" element={<PrivateRoute element={<BuscarProyecto />} />} />
        <Route path="/actualizar-proyecto" element={<PrivateRoute element={<ActualizarProyecto />} />} />
        <Route path="/menu-curso-fortalecimiento" element={<PrivateRoute element={<MenuFortalecimiento />} />} />
        <Route path="/organizaciones/:oid_proyecto_busqueda?" element={<PrivateRoute element={<Organizaciones />} />} />
        <Route path="/mer/:oid_proyecto_busqueda?" element={<PrivateRoute element={<MerOrganizaciones />} />} />
        <Route path="/file-manager" element={<PrivateRoute element={<FileManager />} />} />
        <Route path="/poa/:Mpoa?/:PProyecto?" element={<PrivateRoute element={<Poa />} />} />
        <Route path="/DocumentosFAO" element={<Navigate to="/acceso-restringido" />} />
        <Route path="/DocumentosActualizacion" element={<Navigate to="/acceso-restringido" />} />
        <Route path="/DocumentosOrganizaciones" element={<Navigate to="/acceso-restringido" />} />
        <Route path="/participantes/:id?/" element={<PrivateRoute element={<Participantes />} />} />
        <Route path="/acuerdos-comerciales" element={<PrivateRoute element={<AcuerdosComerciales />} />} />
        <Route path="/app-slider" element={<PrivateRoute element={<AppSlider />} />} />
        <Route path="/sistematizacionIppta/:id?/" element={<PrivateRoute element={<Ippta />} />} />
        <Route path="/encuestaEdah/:id?/" element={<PrivateRoute element={<Edah />} />} />
        <Route path="/caracterizacion" element={<PrivateRoute element={<Caracterizacion />} />} />
        <Route path="/registrar-participante" element={<PrivateRoute element={<Formulario />} />} />
        <Route path="/cursoParticipacion" element={<PrivateRoute element={<CursoFortalecimiento />} />} />
        <Route path="/cursoParticipacionCV" element={<PrivateRoute element={<CFCicloVida />} />} />
        <Route path="/planOperativo/*" element={<PrivateRoute element={<PoaPlanOperativo />} />}/>
        <Route path="/acompanamientoOrg" element={<PrivateRoute element={<AcompanamientoOrg />} />} />
        <Route path="/escuelaDHAATab" element={<PrivateRoute element={<EscuelaDHAATab />} />} />
        <Route path="/enfoqueGenero" element={<PrivateRoute element={<EnfoqueGenero />} />} />
        <Route path="/acceso-restringido" element={<AccesoRestringido />} />
        <Route path="/planes-accion" element={<PrivateRoute element={<PlanAccion />} />} />
        <Route path="/procesar_edah_admin" element={<PrivateRoute element={<ProcesarEDAH />} />} />
        <Route path="/novedad_participante" element={<PrivateRoute element={<NovedadParticipantes />} />} />
        <Route path="/ecas_participante" element={<PrivateRoute element={<EcasParticipante />} />} />
        <Route path="/visita_participante" element={<PrivateRoute element={<DashboardPrincipal />} />} />
        <Route path="/comunix" element={<PrivateRoute element={<AdminPanel />} />} />
        <Route path="/repositorio-documental/:proyecto?" element={<PrivateRoute element={<RepositorioUrl />} />}/>
        <Route path="/implementacion/:proyecto/:mode?" element={<PrivateRoute element={<RepositorioUrl />} />}/>
        <Route path="/proyecto-estructurado" element={<PrivateRoute element={<ProyectEstructurado />} />} />
        <Route path="/informe-actas" element={<PrivateRoute element={<InformeActas />} />} />
        <Route path="/dashboard_financiero" element={<PrivateRoute element={<DashboardFinanciero />} />} />
        <Route path="/estado_financiero" element={<PrivateRoute element={<EstadoFinanciero />} />} />
        <Route path="/proveedores_financiero" element={<PrivateRoute element={<ProveedoresFinanciero />} />} />
        <Route path="/unidad_medida_financiero" element={<PrivateRoute element={<UnidadMedidaFinanciero />} />} />
        <Route path="/productos_financiero" element={<PrivateRoute element={<ProductosFinanciero />} />} />
        <Route path="/entregas_financiero" element={<PrivateRoute element={<EntregasFinanciero />} />} />
        <Route path="/productos_informe" element={<PrivateRoute element={<ProductosInforme />} />} />
        <Route path="/reporte-seguimiento" element={<PrivateRoute element={<ReporteSeguimiento />} />} />
        <Route path="/informe-ocr-actas" element={<PrivateRoute element={<OcrEntregasPanel />} />} />

        <Route path="*" element={<Navigate to="/acceso-restringido" />} />
      </Routes>
      {showNavAndFooter && <LogosFooter />}
    </>
  );
};

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
